var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8815,
    cy: 5.9378,
    r: 2.86364,
    transform: "rotate(13.0831 16.8815 5.9378)",
    stroke: "#96A8BA",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.47421,
    cy: 10.8466,
    r: 2.86364,
    transform: "rotate(13.0831 5.47421 10.8466)",
    stroke: "#96A8BA",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0879,
    cy: 18.4375,
    r: 2.86364,
    transform: "rotate(13.0831 15.0879 18.4375)",
    stroke: "#96A8BA",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9432 6.9349L8.7123 9.56382M16.6503 9.00001L15.6503 15.5M7.6503 13L12.1503 16.5",
    stroke: "#96A8BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.555206565b39935c194e38357a7936ec.svg";
export { ForwardRef as ReactComponent };